import {
    expandImage,
    setReviewPage
} from '../actions/productActions';

import template from 'product-reviews-container.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';
import { onStateChange, getTargetedProduct } from '../utils/productComponentUtils';
import { scrollToElement } from '../../../core/js/utils/scrollUtils';

import { launchAsyncWriteReview } from '@product/js/utils/asyncLaunchers';

export function generateDictionary(state, dictionary, config) {
    const data = {
        recommendedPercentage: 0
    };
    const product = _.get(state, 'product', {});
    const includes = _.get(product, 'productReviews.Includes.Products', {});
    const includedProduct = includes[_.get(product, 'styleNumber', '')];

    if (includedProduct) {
        const reviewStatistics = _.get(includedProduct, 'ReviewStatistics');
        const recommendedCount = _.get(reviewStatistics, 'RecommendedCount', 0);
        const notRecommendedCount = _.get(reviewStatistics, 'NotRecommendedCount', 0);
        const totalReviewCount = recommendedCount + notRecommendedCount;
        const minRecAverage = _.get(state, 'core.constants.pdpOptions.reviews.minimum_recommended_average', 0);
        const recommendedPercentage = totalReviewCount > 0 ? _.round((recommendedCount / totalReviewCount) * 100) : 0;

        if (recommendedPercentage >= minRecAverage) {
            data.recommendedPercentage = recommendedPercentage;
        }
    }

    return Object.assign({}, state, data, dictionary);
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-product-write-review'), (e) => {
        e.preventDefault();

        launchAsyncWriteReview(store, e);
    });

    $(document).on(
        this.scopedEvent('touchend click'),
        this.scopedSelector('.js-pagination__arrow--previous, .js-pagination__arrow--next'),
        (e) => {
            e.preventDefault();
            const pageNumber = e.currentTarget.getAttribute('data-page-number') || 0;

            if (pageNumber > 0) {
                store.dispatch(setReviewPage(pageNumber));
                scrollToElement('.js-product-reviews-top', 20);
                e.currentTarget.blur();
            }
        }
    );

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-expand-image'), (e) => {
        e.preventDefault();
        const src = e.currentTarget.getAttribute('data-normal-image');
        const caption = e.currentTarget.getAttribute('data-image-caption');

        store.dispatch(expandImage(src, caption, e, this.name));
    });
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-product-reviews',
        onStateChange: onStateChange,
        getTargetedProduct: getTargetedProduct,
        attachEvents: attachEvents,
        watch: [
            'product.productReviews',
            'product.reviews'
        ],
        renderType: dDom,
        template: template,
        name: 'productReviewsComponent',
        generateDictionary: generateDictionary
    };

    return generate(config, store, overrides);
}
